
import Vue from "vue";
import { PdfImages } from  "@/utils/pdf-images";
import { PdfViewer } from "@/utils/pdf-viewer";

export default Vue.extend({
	data(){
		return {
			pdfViewer: new PdfViewer(),
			fetching: true
		};
	},
	props: {
		blob: {
			type: Blob,
		},
		images: {
			type: Object as ()=>PdfImages
		}
	},
	computed: {
		useImages():boolean {
			return this.pdfViewer.shouldFetchAsImage();
		},
		imageUrls():string[] {
			if (!this.useImages) return [];
			return this.pdfViewer.getImageUrls();
		}
	},
	watch: {
		blob: {
			handler(){
				this.load();
			}
		},
		images: {
			handler(){
				if (!this.useImages) return;
				this.fetching = true;
				this.pdfViewer.close();
				if (!this.images) return;
				this.pdfViewer.setImages(this.images);
				this.pdfViewer.open();
				setTimeout(() => this.fetching = false ,800);
			}
		}
	},
	methods: {
		async load(){
			if (this.useImages) return;
			this.fetching = true;
			this.pdfViewer.close();
			if (!this.blob) return;
			this.pdfViewer.setPdfBlob(this.blob);
			this.pdfViewer.open();
			setTimeout(() => this.fetching = false ,800);
		},
		async print() {
			let frame = this.$refs.iframe as HTMLIFrameElement || null;
			if (!frame) return;
			window.setTimeout(function () {
				if (!frame.contentWindow) return;
				frame.contentWindow.focus();
				frame.contentWindow.print();
			}, 1000);

		},
	},
	mounted(){
		if (this.useImages){
			this.$emit("fetch-images");
		}else{
			this.$emit("fetch-blob");
		}
		this.load();
	},
	destroyed(){
		this.pdfViewer.close();
	}
});
